import lodash from 'lodash';
import moment from 'moment';

const EVENT_HISTORY_DATE_FORMAT = 'MM/DD/YYYY';

export function formatDate(date, timezoneOffset = '') {
    if (lodash.isNil(date)) {
        return '';
    }
    return timezoneOffset !== ''
        ? moment(date).utcOffset(timezoneOffset).format(EVENT_HISTORY_DATE_FORMAT)
        : moment.utc(date).format(EVENT_HISTORY_DATE_FORMAT);
}
